class ProductDisplay extends HTMLElement {
  constructor() {
    super();
    this.optionFilters = [];
    this._boundHandleFilterClick = this.handleFilterClick.bind(this);
  }

  connectedCallback() {
    this.optionFilters = Array.from(
      this.querySelectorAll(".option-filter-button")
    );
    this.optionFilters.forEach((filter) => {
      filter.addEventListener("click", this._boundHandleFilterClick);
    });

    this.productCards = this.querySelectorAll('product-card');
  }

  disconnectedCallback() {
    if (this.optionFilters && this._boundHandleFilterClick) {
      this.optionFilters.forEach((filter) => {
        filter.removeEventListener("click", this._boundHandleFilterClick);
      });
    }
  }

  handleFilterClick(event) {
    const optionFilter = event.currentTarget;
    const value = optionFilter.dataset.value;
    optionFilter.classList.toggle("is-active");
    const activeValues = this.optionFilters.filter((f) => f.classList.contains("is-active")).map((f) => f.dataset.value);
    
    if (activeValues.length === 0) {
      this.productCards.forEach((card) => card.classList.remove("hidden"));
      return;
    };

    this.productCards.forEach((card) => {
      if (activeValues.includes(card.dataset.option1_value) || activeValues.includes(card.dataset.option2_value)) {
        card.classList.remove("hidden");
      } else {
        card.classList.add("hidden");
      };
    });
  }
}

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.colorSwatches = [];
    this.variantImages = [];
    this._boundHandleColorSwatchClick = this.handleColorSwatchClick.bind(this);
  }

  connectedCallback() {
    this.colorSwatches = Array.from(
      this.querySelectorAll(".product-card-color-box")
    );
    this.variantImages = Array.from(this.querySelectorAll(".cat-card-img"));
    this.colorSwatches.forEach((swatch) => {
      swatch.addEventListener("click", this._boundHandleColorSwatchClick);
    });

    const cart = document.querySelector(
      "script[type='application/json'][data-cart]"
    );
    this.cart = cart ? JSON.parse(cart.textContent) : {};

    // Parse variant data from the embedded JSON
    const variantScript = this.querySelector('script[type="application/json"]');
    this.variants = variantScript ? JSON.parse(variantScript.textContent) : [];

    // Find price elements and form input
    this.priceEl = this.querySelector(
      ".add-to-card-discount-price[data-price]"
    );
    this.regPriceEl = this.querySelector(".add-to-card-reg-price");
    this.variantIdInput = this.querySelector('input[name="id"]');
    this.soldOutEl = this.querySelector("[data-sold-out]");
    this.comingSoonEl = this.querySelector("[data-coming-soon]");
    this.addToCartEl = this.querySelector("[data-add-to-cart]");
    this.textPriceEl = this.querySelector(".add-to-card-button-text-price");
  }

  disconnectedCallback() {
    // Remove event listeners to prevent memory leaks
    if (this.colorSwatches && this._boundHandleColorSwatchClick) {
      this.colorSwatches.forEach((swatch) => {
        swatch.removeEventListener("click", this._boundHandleColorSwatchClick);
      });
    }
  }

  handleColorSwatchClick(event) {
    const swatch = event.currentTarget;
    const color = swatch.dataset.color;
    swatch.classList.add("is-active");
    this.colorSwatches.forEach((sw) => {
      if (sw !== event.currentTarget) {
        sw.classList.remove("is-active");
      }
    });

    // Find the variant by color (prefer option1 or color property)
    let variant = this.variants.find((v) => {
      if (v.option1 && typeof v.option1 === "string") {
        return v.option1.toLowerCase() === color.toLowerCase();
      }
      if (v.color && typeof v.color === "string") {
        return v.color.toLowerCase() === color.toLowerCase();
      }
      return false;
    });
    // Fallback to previous method if not found
    if (!variant) {
      variant = this.variants.find((v) => {
        return Object.values(v).some(
          (val) =>
            typeof val === "string" && val.toLowerCase() === color.toLowerCase()
        );
      });
    }
    if (variant) {
      const button = this.querySelector(".add-to-card-button");
      //const buttonIcon = this.querySelector(".add-to-card-button-icon");
      const addedBox = this.querySelector(".added-box");

      if (this.priceEl) {
        this.priceEl.textContent = window.Shopify.formatMoney(variant.price);
        this.priceEl.classList.remove("hidden");
      }
      if (this.regPriceEl) {
        if (
          variant.compare_at_price &&
          variant.compare_at_price > variant.price
        ) {
          this.regPriceEl.textContent = window.Shopify.formatMoney(
            variant.compare_at_price
          );
          this.regPriceEl.classList.remove("hidden");
        } else {
          this.regPriceEl.classList.add("hidden");
        }
      }
      // Update URL with variant ID
      this.querySelectorAll("a").forEach((a) => {
        if (a && a.href) {
          const url = new URL(a.href, window.location.origin);
          url.searchParams.set("variant", variant.id);
          a.href = url.toString();
        }
      });

      // Update hidden variant ID input
      if (this.variantIdInput) {
        this.variantIdInput.value = variant.id;
      }
      // Update button state
      const cartItem = this.cart.items?.find((item) => item.id === variant.id);
      const cartQuantity = cartItem?.quantity || 0;
      const isInventorySoldOut = variant.inventory_quantity !== null && variant.inventory_quantity <= cartQuantity;
      
      if (button) {
        button.classList.remove("is-prom", "is-sold", "is-coming");
        //if (buttonIcon) buttonIcon.classList.remove("hidden");
        if (addedBox) addedBox.classList.add("hidden");
        // Coming soon
        if (variant.inventory_management !== null && variant.sku === null) {
          button.classList.add("is-coming");
          if (this.comingSoonEl) {
            this.comingSoonEl.classList.remove("hidden");
            this.comingSoonEl.textContent = this.getComingSoonLabel();
            this.addToCartEl.classList.add("hidden");
            this.textPriceEl.classList.add("hidden");
          }
          //if (buttonIcon) buttonIcon.classList.add("hidden");
          if (this.regPriceEl) this.regPriceEl.classList.add("hidden");
          if (this.priceEl) this.priceEl.classList.add("hidden");
          if (this.soldOutEl) this.soldOutEl.classList.add("hidden"); this.soldOutEl.classList.remove("display");
        } else if (!variant.available || isInventorySoldOut) {
          // Sold out
          button.classList.add("is-sold");
          if (this.soldOutEl) {
            this.soldOutEl.classList.remove("hidden");
            this.soldOutEl.textContent = this.getSoldOutLabel();
            isInventorySoldOut ? this.soldOutEl.classList.add("display") : this.soldOutEl.classList.remove("display");
            this.addToCartEl.classList.add("hidden");
            this.textPriceEl.classList.add("hidden");
          }
          //if (buttonIcon) buttonIcon.classList.add("hidden");
          if (this.regPriceEl) this.regPriceEl.classList.add("hidden");
          if (this.priceEl) this.priceEl.classList.add("hidden");
          if (this.comingSoonEl) this.comingSoonEl.classList.add("hidden");
        } else if (
          variant.compare_at_price &&
          variant.compare_at_price > variant.price
        ) {
          // Discounted
          button.classList.add("is-prom");
          if (this.soldOutEl) this.soldOutEl.classList.add("hidden"); this.soldOutEl.classList.remove("display");
          this.addToCartEl.classList.remove("hidden");
          this.textPriceEl.classList.remove("hidden");
          //if (buttonIcon) buttonIcon.classList.remove("hidden");
        } else {
          if (this.priceEl) this.priceEl.classList.remove("hidden");
          if (this.soldOutEl) this.soldOutEl.classList.add("hidden"); this.soldOutEl.classList.remove("display");
          if (this.comingSoonEl) this.comingSoonEl.classList.add("hidden");
          if (this.addToCartEl) this.addToCartEl.classList.remove("hidden");
          if (this.textPriceEl) this.textPriceEl.classList.remove("hidden");
        }
      }
      // Added box if variant is in cart
      if (this.cart.items.some((item) => item.id === variant.id) && !isInventorySoldOut) {
        //buttonIcon.classList.add("hidden");
        addedBox.classList.remove("hidden");
        const qtyText = addedBox.querySelector(".added-qty-text");
        if (qtyText) {
          qtyText.textContent = this.cart.items.find(
            (item) => item.id === variant.id
          ).quantity;
        }
      }
      if (this.comingSoonEl?.classList.contains("hidden") === false) {
        this.priceEl.classList.add("hidden");
        this.soldOutEl.classList.add("hidden");
        this.addToCartEl.classList.add("hidden");
        this.textPriceEl.classList.add("hidden");
        this.regPriceEl.classList.add("hidden");
        //buttonIcon.classList.add("hidden");
        addedBox.classList.add("hidden");
      }
      // Update product image only if variant has an image
      this.variantImages.forEach((image) => {
        if (image && image.dataset.color === color) {
          image.classList.remove("hidden");
        } else if (image) {
          image.classList.add("hidden");
        }
      });
    }
  }

  getSoldOutLabel() {
    const soldOutEl = this.querySelector("[data-sold-out]");
    return soldOutEl ? soldOutEl.textContent.toUpperCase() : "SOLD OUT";
  }

  getComingSoonLabel() {
    const comingSoonEl = this.querySelector("[data-coming-soon");
    return comingSoonEl ? comingSoonEl.textContent.toUpperCase() : "COMING SOON";
  }
}

if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}

if (!customElements.get("product-display")) {
  customElements.define("product-display", ProductDisplay);
}

class Product extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.initElements();
    this.MainSlider = new Splide(this.querySelector(".product-splide"), {
      type: "loop",
      speed: 600,
      autoHeight: true,
      arrows: false,
      pagination: "slider",
      gap: '2rem',
      breakpoints: {
      },
    }).mount();

    const slideElements = this.querySelectorAll('.splide__slide:not(.splide__slide--clone)');
    this.variant2imageSlidesMap = {};
    Array.from(slideElements).forEach(slide => {
      if (!this.variant2imageSlidesMap[slide.dataset.variantId]) {
        this.variant2imageSlidesMap[slide.dataset.variantId] = [];
      };
      this.variant2imageSlidesMap[slide.dataset.variantId].push(slide.cloneNode(true));
    });

    const currentVariant = this.getCurrentVariant();
    if (currentVariant) {
      this.updateMedia(currentVariant.id);
    };
  }
  initElements() {
    this.variantIdInput = this.querySelector('input[name="id"]');
    const variantScript = this.querySelector('script[type="application/json"]');
    this.variants = variantScript ? JSON.parse(variantScript.textContent) : [];
    this.options = this.querySelectorAll(".spec-drops");
    this.activeOptions = Array.from( this.querySelectorAll(".spec-drop-toggle") );
    this.lists = this.querySelectorAll(".spec-drop-list-inner");
    this.btn = this.querySelector(".add-to-card-wrap");
    this.attachOptionListeners();
    this.header = this.querySelector('.prod-info-header');
  }

  getCurrentVariant() {
    if (!this.variants || !this.variantIdInput) return null;
    const currentVariantId = this.variantIdInput.value;
    return this.variants.find((v) => v.id == currentVariantId);
  }

  updateMedia(newVariantId) {
    const variant = this.variants.find((v) => v.id == newVariantId);

    if (!variant || !this.MainSlider) {
      return;
    };

    this.MainSlider.remove(slide => true);
    this.variant2imageSlidesMap[variant.id].forEach(slide => {
      this.MainSlider.add(slide);
    });
    this.MainSlider.go(0);
  }

  attachOptionListeners() {
    this.options.forEach((option) => {
      option.querySelectorAll(".spec-drop-list-inner a").forEach((item) => {
        item.addEventListener("click", this.handleOptionClick.bind(this));
      });
    });
  }
  async handleOptionClick(event) {
    event.preventDefault();
    const option = event.currentTarget;

    const activeOption = option.closest('.spec-drop-list').previousElementSibling;
    const oldValue = activeOption.dataset.value;
    const newValue = option.dataset.value;

    activeOption.dataset.value = newValue;
    if (activeOption.querySelector('.color-circle') !== null) activeOption.querySelector('.color-circle').replaceWith(option.querySelector('.color-circle'));
    activeOption.querySelector('.text-15').replaceWith(option.querySelector('.text-15'));

    option.classList.add('hidden');
    Array.from(option.parentElement.children).find(el => el.dataset.value === oldValue).classList.remove('hidden');

    const optionValues = this.activeOptions.map(option => option.dataset.value);
    const newVariantId = this.variants.find(v => isArrEqual(v.options, optionValues))?.id;
    this.variantIdInput.value = newVariantId;

    const sectionId = option.closest("section").getAttribute("id").replace("shopify-section-", "");

    this.fetchVariant(newVariantId, sectionId);

    function isArrEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;

      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) return false;
      };

      return true;
    };
  }

  async fetchVariant(newVariantId, sectionId) {
    try {
      this.updateMedia(newVariantId);

      fetch(window.location.pathname + `?variant=${newVariantId}&sections=${sectionId}`)
        .then(response => response.json())
        .then(data => {
          const html = new DOMParser().parseFromString(data[sectionId], "text/html");
          const activeOptions = html.querySelectorAll(".spec-drop-toggle");
          const lists = html.querySelectorAll(".spec-drop-list-inner");
          const btn = html.querySelector(".add-to-card-wrap");

          this.activeOptions.forEach((option, index) => {
            option.innerHTML = activeOptions[index].innerHTML;
          });
          this.lists.forEach((list, index) => {
            list.innerHTML = lists[index].innerHTML;
          });
          this.btn.replaceWith(btn);

          // Update the URL
          const url = new URL(window.location);
          url.searchParams.set("variant", newVariantId);
          window.history.replaceState({ variant: newVariantId }, "", url);

          // Re-initialize elements and event listeners
          this.initElements();
        });
    } catch (error) {
      console.error("Error fetching variant:", error);
    }
  }
  updatePrice(newVariantId) {
    const variant = this.findVariant(newVariantId);

    if (variant) {
      const priceEl = this.querySelector(
        ".add-to-card-discount-price[data-price]"
      );
      const regPriceEl = this.querySelector(".add-to-card-reg-price");

      if (priceEl) {
        priceEl.textContent = window.Shopify.formatMoney(variant.price);
      }

      if (regPriceEl) {
        if (
          variant.compare_at_price &&
          variant.compare_at_price > variant.price
        ) {
          regPriceEl.textContent = window.Shopify.formatMoney(
            variant.compare_at_price
          );
          regPriceEl.style.display = "";
        } else {
          regPriceEl.style.display = "none";
        }
      }
      if (this.variantIdInput) {
        this.variantIdInput.value = variant.id;
      }
    }
  }
  updateVariantsIdsOption(newVariantId) {
    const variant = this.findVariant(newVariantId);
    if (variant) {
      this.options.forEach((option) => {
        option.querySelectorAll(".spec-drop-list-inner a").forEach((item) => {
          for (const newOption of variant.option) {
            if (newOption.value == item.dataset.value) {
              item.classList.add("is-active");
            } else {
              item.classList.remove("is-active");
            }
          }
        });
      });
    }
  }
}

if (!customElements.get("cstm-product")) {
  customElements.define("cstm-product", Product);
}
